import React from 'react';
export const arrowLeftSvg = () => {
    return (
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M-4.62904e-07 1.41L4.55669 6L-6.16331e-08 10.59L1.40282 12L7.37228 6L1.40282 -6.19452e-08L-4.62904e-07 1.41Z" fill="black" fillOpacity="0.2"/>
        </svg>
    )
}